
const FamilyMemberModalTypeEnum = {
    CHANGE_LA: "CHANGE_LA",
    CHANGE_SECONDARY_LA: "CHANGE_SECONDARY_LA",
    ADD_SECONDARY_LA: "ADD SECONDARY LA",
    CHANGE_PROPOSER: "CHANGE_PROPOSER",
    ADD_INSURED: "ADD_INSURED",
    ADD_NEED: "ADD_NEED"
}

export default FamilyMemberModalTypeEnum;